import PageHeader from "@/components/site/PageHeader";
import { Livestream } from "@/components/site/Sections";
import { CTABand } from "@/components/site/AboutSections";
import { usePageMeta } from "@/lib/usePageMeta";

export default function WatchPage() {
  usePageMeta(
    "Watch Live & Recent Messages",
    "Watch RE//FORM PLACE CHI live every Sunday at 12:30 PM CST and catch up on recent messages from Pastor Phillip and Prophet Dr. Chantel Varnado.",
  );
  return (
    <div data-testid="watch-page">
      <PageHeader
        crumb="Watch"
        eyebrow="Watch Online"
        title="Join Us"
        accent="Live"
        intro="Can't be in the room? Worship with us from anywhere — Sundays at 12:30 PM CST, plus every recent message on demand."
        image="/media/worship.poster.jpg"
      />
      <Livestream />
      <CTABand
        eyebrow="Need Prayer?"
        title="We'd Love To Pray With You"
        text="Send a request and our intercessory prayer team will stand with you."
        primary={{ to: "/prayer", label: "Request Prayer" }}
        secondary={{ to: "/give", label: "Give Online" }}
      />
    </div>
  );
}
